import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ContentReviewChip from "../../components/ContentReviewChip";
import { COLORS } from "../../theme/tokens";

export default function SectionHeader({
  eyebrow,
  heading,
  lead,
  subheading,
  align = "left",
  reviewStatus,
}) {
  return (
    <Box sx={{ mb: 4, textAlign: align }}>
      {(eyebrow || reviewStatus) && (
        <Stack
          direction="row"
          spacing={1}
          sx={{
            alignItems: "center",
            justifyContent: align === "center" ? "center" : "flex-start",
            flexWrap: "wrap",
            mb: "10px",
          }}
        >
          {eyebrow && (
            <Typography
              sx={{
                display: "block",
                color: COLORS.red,
                fontWeight: 800,
                letterSpacing: "0.07em",
                fontFamily: "Poppins, sans-serif",
                fontSize: "0.76rem",
                textTransform: "uppercase",
              }}
            >
              {eyebrow}
            </Typography>
          )}
          {reviewStatus && <ContentReviewChip status={reviewStatus} />}
        </Stack>
      )}
      {heading && (
        <Typography
          variant="h2"
          sx={{
            fontFamily: "windroos, Georgia, serif",
            color: COLORS.blue,
            fontSize: "clamp(32px, 4.4vw, 56px)",
            lineHeight: 1.04,
            mt: 0,
            mb: subheading || lead ? "18px" : 0,
          }}
        >
          {heading}
        </Typography>
      )}
      {subheading && (
        <Typography
          variant="subtitle1"
          component="p"
          sx={{ color: COLORS.muted, mb: lead ? 1 : 0 }}
        >
          {subheading}
        </Typography>
      )}
      {lead && (
        <Typography
          sx={{
            color: COLORS.muted,
            maxWidth: 680,
            mx: align === "center" ? "auto" : 0,
            fontSize: "clamp(1.02rem, 1.5vw, 1.22rem)",
            lineHeight: 1.6,
          }}
        >
          {lead}
        </Typography>
      )}
    </Box>
  );
}
